import { FrequentPassageRequest, QueryListResult } from '@legacy-types';
import { objectToParam } from '../../libs/utils';
import axios from '../api';
import { Nullable } from '@shared/utils/types';

export async function getFrequentPassageRequests(
  eventId: number | undefined,
  params = {}
): Promise<QueryListResult<FrequentPassageRequest>> {
  if (typeof eventId === 'undefined') {
    return Promise.reject(new Error('Invalid eventId'));
  }

  const parameters = objectToParam({
    ...params,
    'filter[event_id]': eventId,
  });

  return await axios
    .get<QueryListResult<FrequentPassageRequest>>(`/frequent-passage-requests?${parameters}`)
    .then((response) => response.data);
}

export async function deleteFrequentPassageRequest(id: number) {
  const { data } = await axios.delete(`frequent-passage-requests/${id}`);

  return data;
}

export type CreateFrequentPassageRequestRequest = Nullable<
  Pick<
    FrequentPassageRequest,
    'registrationId' | 'crewMemberId' | 'vehicleType' | 'licensePlate' | 'frequentPassageStickerTypeId'
  >
>;

export async function createFrequentPassageRequest(
  values: CreateFrequentPassageRequestRequest
): Promise<FrequentPassageRequest> {
  const { data } = await axios.post(`/frequent-passage-requests`, values);

  return data;
}

export type RejectFrequentPassageRequestRequest = {
  remark: string | null;
};

export async function rejectFrequentPassageRequest(
  frequentPassageRequestId: number,
  values: RejectFrequentPassageRequestRequest
): Promise<FrequentPassageRequest> {
  const { data } = await axios.post(`/frequent-passage-requests/${frequentPassageRequestId}/reject`, values);

  return data;
}

export async function approveFrequentPassageRequest(frequentPassageRequestId: number): Promise<FrequentPassageRequest> {
  const { data } = await axios.post(`/frequent-passage-requests/${frequentPassageRequestId}/approve`);

  return data;
}

export type RedeemFrequentPassageRequestRequest = {
  code: string;
  internalNote: string | null;
};

export async function redeemFrequentPassageRequest(
  id: number,
  values: RedeemFrequentPassageRequestRequest
): Promise<FrequentPassageRequest> {
  const { data } = await axios.post(`/frequent-passage-requests/${id}/redeem`, values);

  return data;
}
